export default __webpack_public_path__ + "static/media/pak-navy.fbe83736.png";